const closest = require('closest');
const to_array = require('./to_array');
const GlobalAlerts = require('./GlobalAlerts');
const template     = require('lodash/template');
const dialog = template(require('../templates/pagamento-relatorio.html'));
const Lang = require('lang');

function clickHandler(event) {

  const form = closest(event.target, 'form');
  const checkedReports = form.querySelectorAll('.js-relatorio-checkbox:checked');

  if(checkedReports.length) {
    confirmationDialog(form);
  } else {
    emptyAlert();
  }
}

function emptyAlert() {
  bootbox.alert({
    title: Lang.get('js/src/functions/PagarRelatorio.ops'),
    message: Lang.get('js/src/functions/PagarRelatorio.no_report_was_selected'),
    size: 'small'
  });
}

function confirmationDialog(form) {
  const confirmation = bootbox.dialog({
    title: Lang.get('js/src/functions/PagarRelatorio.report_payment_confirmation'),
    message: dialog({
      dataLabel: Lang.get('js/src/functions/PagarRelatorio.data_payment_label'),
      dataExplication: Lang.get('js/src/functions/PagarRelatorio.data_payment_explication')
    }),
    buttons: {
      cancel: {
        label: Lang.get('js/src/functions/PagarRelatorio.cancel'),
        className: 'btn-danger',
      },
      confirm: {
        label: Lang.get('js/src/functions/PagarRelatorio.confirm'),
        className: 'btn-success',
        callback: function sendForm(event) {
          const dataPagamentoInput = this.find('#dataPagamento').get(0);

          if(!/^\d{2}\/\d{2}\/\d{4}$/.test(dataPagamentoInput.value)) {
            GlobalAlerts.createAndShow({
              title: Lang.get('js/src/functions/PagarRelatorio.ops'),
              message: Lang.get('js/src/functions/PagarRelatorio.invalid_date_format'),
              type: 'danger'
            });
            return false;
          }

          form.appendChild(dataPagamentoInput.cloneNode());

          $(form).trigger('submit');

          return false;
        }
      }
    }
  });

  confirmation.on('shown.bs.modal', function() {
    const input = $(this).find('#dataPagamento');
    input.datepicker();
    input.datepicker('setDate', 'now');
  });
}

function addEventListener(btn) {
  btn.addEventListener('click', clickHandler);
}

function PagarRelatorio() {
  const sendButtons = to_array(document.getElementsByClassName('js-send-payment-confirmation'));
  const buttonsCheckAll = document.querySelectorAll('.js-select-all-reports');

  sendButtons.forEach(addEventListener);

  buttonsCheckAll.forEach((currentButton) => {
    currentButton.addEventListener('click', clickCheckAllReportsHandler)
  });
}

function clickCheckAllReportsHandler(event) {
  const buttonsCheckAll = document.querySelectorAll('.js-select-all-reports');

  buttonsCheckAll.forEach((currentButton) => {
    const isAllSelected = currentButton.dataset.selectAll;

    if (isAllSelected === 'true') {
      currentButton.innerHTML =  Lang.get('js/src/functions/PagarRelatorio.check_all');
      currentButton.dataset.selectAll = 'false';

      return checkOrUncheck(false);
    }

    currentButton.dataset.selectAll = 'true';
    currentButton.innerHTML = Lang.get('js/src/functions/PagarRelatorio.uncheck_all');

    return checkOrUncheck(true);
  })
}

function checkOrUncheck(checkValue) {
  const checkboxes = document.querySelectorAll('.js-relatorio-checkbox');

  checkboxes.forEach((currentCheckbox) => {
    const labelCheckbox = currentCheckbox.closest('label');
    currentCheckbox.checked = checkValue;

    if (checkValue) {
      labelCheckbox.classList.add('active');
      return;
    }

    labelCheckbox.classList.remove('active');
  })
}

exports.init = PagarRelatorio;
